import env from "../../env";
import React from "react";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";
import AsyncSelect from "react-select/async";
import { connect } from "react-redux";
import { set_visibility_modal } from "../../redux/actions";
import Spinner from "../Spinner";
import axios from "axios";

const darkTheme = {
  primary25: "#1266f1",
  primary50: "#1E88E5",
  primary75: "#42A5F5",
  primary: "#BBDEFB",
  dangerLight: "#f93154",
  danger: "#E57373",
  neutral90: "#fff",
  neutral80: "#f9f9f9",
  neutral70: "#f5f5f5",
  neutral60: "#eeeeee",
  neutral50: "#e0e0e0",
  neutral40: "#bdbdbd",
  neutral30: "#9e9e9e",
  neutral20: "#757575",
  neutral10: "#616161",
  neutral5: "#4f4f4f",
  neutral0: "#262626",
};

const visibilityOptions = [
  "Public",
  "Followers",
  "People I Follow",
  "Only Me",
  "Custom",
];

class VisibilityModal extends React.Component {
  constructor(props) {
    super();
    this.state = {
      updating: false,
      flavor: props?.visibilityModal?.emission?.visibility?.flavor,
      viewers: [],
    };
    this.searchCallbackRef = React.createRef(null);
  }

  componentDidMount() {
    if (this.props.socket) this.initializeSocket();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.visibilityModal?.emission?.visibility?.flavor &&
      this.props.visibilityModal?.emission?.visibility?.flavor !==
        prevProps.visibilityModal?.emission?.visibility?.flavor
    )
      this.setState((curr) => ({
        ...curr,
        flavor: this.props.visibilityModal?.emission?.visibility?.flavor,
      }));
    if (!prevProps.socket && this.props.socket) this.initializeSocket();
  }

  componentWillUnmount() {
    if (this.props.socket) this.props.socket.off("user-list-modal");
  }

  initializeSocket = () => {
    if (!this.props.socket) return;
    this.props.socket.off("user-list-modal");

    this.props.socket.on("user-list-modal", (list) => {
      try {
        if (this.searchCallbackRef.current)
          this.searchCallbackRef.current(
            list.map((user) => {
              return {
                label: (
                  <div className="d-flex align-items-center">
                    <div className="search-avatars ms-2">
                      <div
                        className="fit-images search-avatars fit-round"
                        style={{
                          backgroundImage: `url("${process.env.REACT_APP_BUCKET_HOST}/${env.INSTANCE_ID}/thumbnails/${user.avatar.thumbnail}")`,
                          borderRadius: "50%",
                        }}
                      ></div>
                    </div>
                    <div className="fw-bold ms-2">@{user.username}</div>
                    <div className="ms-2">{user.displayName}</div>
                  </div>
                ),
                value: user._id,
                user,
              };
            })
          );
      } catch (err) {
        console.log("user-list error", err, list);
      }
    });
  };

  setViewers = (viewers) => {
    this.setState((curr) => ({
      ...curr,
      viewers: viewers.map((v) => v.user.user_id),
    }));
  };

  toggleShowModal = () =>
    this.props.set_visibility_modal({
      ...this.props.visibilityModal,
      shown: !this.props.visibilityModal.shown,
    });

  flavorChange = (flavor) => {
    if (!this.state.updating)
      this.setState((curr) => ({
        ...curr,
        flavor,
      }));
  };

  loadOptions = (text, callback) => {
    if (!text) return callback([]);
    this.searchCallbackRef.current = callback;
    this.props.socket.emit("user-search-modal", text);
  };

  saveChanges = () =>
    this.setState(
      (curr) => ({
        ...curr,
        updating: true,
      }),
      () =>
        axios
          .post(process.env.REACT_APP_LAMBDA_EMISSIONS + "/visibility", {
            _id: this.props.visibilityModal.emission._id,
            flavor: this.state.flavor,
            viewers: this.state.viewers,
          })
          .then((res) => {
            this.props.visibilityModal.updateEmission(res.data.emission);
            this.toggleShowModal();
          })
          .catch((err) => {
            console.log("error", err);
            alert("An error occurred. Please try again later.");
          })
          .finally(() =>
            this.setState((curr) => ({
              ...curr,
              updating: false,
            }))
          )
    );

  render() {
    const emission = this.props.visibilityModal.emission;
    const modalShown = this.props.visibilityModal.shown;
    return (
      <>
        {typeof window !== "undefined" && window.navigator ? (
          <MDBModal
            open={modalShown}
            staticBackdrop
            onClosePrevented={this.toggleShowModal}
            tabIndex="-1"
          >
            <MDBModalDialog>
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>
                    Change Visibility of #{emission?.emissionID}
                  </MDBModalTitle>
                  <MDBBtn
                    className="btn-close"
                    color="none"
                    onClick={this.toggleShowModal}
                  ></MDBBtn>
                </MDBModalHeader>
                <MDBModalBody>
                  <div className="w-100 d-flex flex-column">
                    {visibilityOptions.map((option) => (
                      <MDBBtn
                        key={option}
                        color="link"
                        size="lg"
                        rippleColor="primary"
                        onClick={() => this.flavorChange(option)}
                        className={`w-100 text-center cursor-pointer ${
                          option === this.state.flavor ? "active" : ""
                        }`}
                      >
                        {option}
                      </MDBBtn>
                    ))}
                  </div>
                  {this.state.flavor === "Custom" && (
                    <AsyncSelect
                      cacheOptions
                      onChange={this.setViewers}
                      loadOptions={this.loadOptions}
                      defaultOptions
                      placeholder="Allowed Users"
                      isMulti
                      theme={(theme) => {
                        if (
                          this.props.userInfo.userSettings.theme === "default"
                        ) {
                          return theme;
                        } else
                          return {
                            ...theme,
                            colors: {
                              ...theme.colors,
                              ...darkTheme,
                            },
                          };
                      }}
                      className="mt-2 skip-ripple no-route w-100"
                    />
                  )}
                </MDBModalBody>
                <MDBModalFooter>
                  {this.props.visibilityModal?.emission?.visibility?.flavor !==
                    this.state.flavor && (
                    <MDBBtn
                      color="success"
                      onClick={this.saveChanges}
                      disabled={this.state.updating}
                    >
                      {this.state.updating ? (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Saving
                        </>
                      ) : (
                        <>
                          <i className="fas fa-save me-2" />
                          Save
                        </>
                      )}
                    </MDBBtn>
                  )}
                  <MDBBtn
                    className="bg-gray"
                    color="dark"
                    onClick={this.toggleShowModal}
                  >
                    Close
                  </MDBBtn>
                </MDBModalFooter>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>
        ) : (
          <></>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  socket: state.socket,
  userInfo: state.userInfo,
  visibilityModal: state.visibilityModal,
});

export default connect(mapStateToProps, { set_visibility_modal })(
  VisibilityModal
);
